export enum ImportRouterStateKey {
  ORIGIN_ROUTE = 'originRoute',
  NAME = 'name',
  DATA = 'data',
}
